import { map } from 'rxjs/operators';
import { Component } from '@angular/core';
import { ViewportScroller } from '@angular/common';

import { ISimpleItem } from '@core/models/simple-item.model';
import { ShopStoreRefiner } from '@common/refiners/shop.refiner';

@Component({
  selector: 'app-marketplace-category-tabs-blocks',
  templateUrl: './marketplace-category-tabs-blocks.component.html',
})
export class MarketplaceCategoryTabsBlocksComponent {
  filters$ = this.shopRefiner.selectActiveShopEnabledStores.pipe(
    map(stores =>
      stores.map(store => {
        return {
          value: store?.id,
          label: store?.name,
        };
      }),
    ),
  );

  constructor(
    private shopRefiner: ShopStoreRefiner,
    private readonly viewportScroller: ViewportScroller,
  ) {}

  onClickFilter(event: ISimpleItem): void {
    this.viewportScroller.scrollToAnchor(event.value);
  }
}
